import {
  ChevronDown,
  ChevronUp,
  ArrowUpRight,
  LockKeyhole,
  Presentation as PresentationIcon,
} from 'lucide-react';
import { Presentation, presentations } from '@presentations/presentations';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Library.module.css';

export const PresentationList = () => {
  const [showOlderPresentations, setShowOlderPresentations] = useState(false);
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  const sorted = [...presentations].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );
  const recent = sorted.filter((entry) => new Date(entry.date) >= oneWeekAgo);
  const older = sorted.filter((entry) => new Date(entry.date) < oneWeekAgo);
  const card = (entry: Presentation) => (
    <Link key={entry.folder} to={`/${entry.folder}`} className={styles.deck}>
      <span className={styles.deckIcon}>
        <PresentationIcon size={22} />
      </span>
      <div>
        <h2>{entry.title}</h2>
        <p>{entry.description}</p>
        <span className={styles.meta}>
          {entry.location} ·{' '}
          {new Date(entry.date).toLocaleDateString('nl-NL', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
        </span>
      </div>
      <ArrowUpRight size={20} className={styles.arrow} />
    </Link>
  );
  return (
    <main className={styles.library}>
      <header className={styles.header}>
        <Link to="/" className={styles.logo}>
          <PresentationIcon size={22} />
          PresentR
        </Link>
        <span>RobotCandy</span>
      </header>
      <div className={styles.content}>
        <div className={styles.intro}>
          <div>
            <h1>PresentR</h1>
            <p>Presentaties van RobotCandy. Klaar voor het grote scherm.</p>
          </div>
          <Link to="/private" className={styles.primary}>
            <LockKeyhole size={16} />
            Besloten presentaties
            <ArrowUpRight size={16} />
          </Link>
        </div>
        <div className={styles.list}>{recent.map(card)}</div>
        {older.length > 0 && (
          <section className={styles.archive}>
            <button
              className={styles.archiveToggle}
              aria-label="Voorgaande presentaties"
              onClick={() => setShowOlderPresentations(!showOlderPresentations)}
              aria-expanded={showOlderPresentations}
              aria-controls="older-presentations"
            >
              <span>
                Voorgaande presentaties <small>{older.length}</small>
              </span>
              {showOlderPresentations ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
            </button>
            {showOlderPresentations && (
              <div id="older-presentations" className={styles.list}>
                {older.map(card)}
              </div>
            )}
          </section>
        )}
        <footer className={styles.footer}>
          Een verhaal op het scherm. De regie in jouw handen.
        </footer>
      </div>
    </main>
  );
};
